<template>
  <div class="container" id="app">
    <div class="card-form">
      <div class="card-form__inner">
        <img
          :src="getImage()"
          class="card-img-top rounded-corners"
          id="logoTop"
        />

        <div class="card-body">
          <center>
            <h1 class="card-title">Success!</h1>
            <br />

            <h4>You're signed up for {{ this.camp.campName }}</h4>
            <br />
            <button
              class="card-form__button rounded-pill"
              @click="nextSteps"
              style="max-width: 45%"
            >
              Keep Browsing
            </button>
          </center>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    camp: Object,
    campers: Array,
  },
  data() {
    return {}
  },
  methods: {
    nextSteps() {
      this.$router.push(
        `/coach/${this.$route.params.coachId}/${this.$route.params.primaryColor}/${this.$route.params.secondaryColor}`,
      )
    },
    getImage() {
      if (this.camp.campLogo == null || this.camp.campLogo == '')
        return '/landscape.svg'
      else return this.camp.campLogo
    },
  },
}
</script>

<style scoped>
button {
  border-radius: 0.5rem !important;
  transition: filter 0.3s ease;
}

button:hover {
  filter: brightness(0.9);
}
</style>
